import type { TFunction } from 'i18next';

/**
 * The order form's seeded-field helpers, extracted as a seam (the form sits
 * at the 600-line cap): amber while a field still holds exactly what we put
 * there, and the "Suggested N" note kept visible once the user departs.
 */
export function makeSeedHelpers(
  seeded: Record<string, string | undefined>,
  t: TFunction,
  styles: Record<string, string>,
) {
  /** Amber only while the field still holds exactly what we put there. */
  const seededCls = (field: string, value: string): string =>
    seeded[field] !== undefined && seeded[field] === value ? ` ${styles.prefilled}` : '';
  /** What we suggested, kept visible once the user decides against it.
   *  `show` writes the suggestion the way its field writes values — a date
   *  field's yyyy/mm/dd rather than the stored 'YYYY-MM-DD'. */
  const seedNote = (field: string, value: string, numeric = false, show = (v: string) => v) => {
    const was = seeded[field];
    if (was === undefined || was === value) return null;
    return (
      <span className={styles.seedNote}>
        {t(numeric ? 'logistics.stockDialog.wasEstimated' : 'logistics.orderDialog.wasSuggested', {
          value: show(was),
        })}
      </span>
    );
  };
  return { seededCls, seedNote };
}
